import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';

import Statistics from './Statistics';

const StyledCard = styled(Card)`
  background-color: #FFFFFF;
  border-radius: 8px;
  border: none;
`;

const StatsCard = ({ className, style, ...rest }) => {
  return (
    <StyledCard className={className} style={style}>
      <Statistics {...rest} />
    </StyledCard>
  );
};

export default StatsCard;
